import { BoundingBoxType as BoundingBox } from '@allenai/pdf-components';

export type Citation = {
  citedPaperId: number;
  boundingBoxes: BoundingBox[];
  metadata: object;
};

export function paperMageBoxToBoundingBox(
  mageBox: number[],
  pageDimensions: { height: number; width: number },
): BoundingBox {
  return {
    left: mageBox[0] * pageDimensions.width,
    top: mageBox[1] * pageDimensions.height,
    width: mageBox[2] * pageDimensions.width,
    height: mageBox[3] * pageDimensions.height,
    page: mageBox[4],
  };
}
